import {useMutation} from "@tanstack/react-query";
import {resendUserManagementInvitationMutationOptions} from "./resend-user-management-invitation.mutation-options";

export function useResendUserManagementInvitation() {
  return useMutation(resendUserManagementInvitationMutationOptions());
}
